<template>
  <div class="d2-layout-header-aside-group" :style="styleLayoutMainGroup" :class="{ grayMode: grayActive }">
    <!-- 半透明遮罩 -->
    <div class="d2-layout-header-aside-mask"></div>
    <!-- 主体内容 -->
    <div class="d2-layout-header-aside-content" flex="dir:top">
      <!-- 顶栏 -->
      <div class="d2-theme-header" flex>
        <div class="logo-group" flex-box="0">
          <img :src="`${$baseUrl}image/theme/${themeActiveSetting.name}/logo/all.png`" />
        </div>
        <div flex-box="1"></div>
        <!-- 顶栏右侧 -->
        <div class="d2-header-right" flex-box="0">
          <img :src="`${$baseUrl}image/theme/${themeActiveSetting.name}/logo/logo.png`" height="40" />
        </div>
      </div>
      <!-- 中栏 -->
      <div class="d2-theme-header d2-theme-header-middle" flex>
        <div class="logo-group" flex-box="1">
          <!-- <i class="el-icon-location-outline"></i>
          <el-dropdown>
            <span class="el-dropdown-link">
              上海站<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>北京站</el-dropdown-item>
              <el-dropdown-item>江西站</el-dropdown-item>
              <el-dropdown-item>浙江站</el-dropdown-item>
              <el-dropdown-item disabled>上海站</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown> -->
        </div>
        <!-- <el-divider direction="vertical" class="d2-ml-15 d2-mr-15"></el-divider>
        <div flex-box="1">
          <el-input placeholder="全局搜索" prefix-icon="el-icon-search" v-model="input" size="mini" class="d2-theme-search">
          </el-input>
        </div> -->
        <!-- 顶栏右侧 -->
        <div class="d2-header-right" flex-box="0">
          <d2-header-user />
        </div>
      </div>

      <div class="d2-theme-header d2-theme-header-bottom" flex>
        <d2-menu-header flex-box="1" />
      </div>
      <!-- 下面 主体 -->
      <div class="d2-theme-container">
        <!-- 主体 -->
        <div class="d2-theme-container-main">
          <!-- 内容 -->
          <transition name="fade-scale">
            <div v-show="!searchActive" class="d2-theme-container-main-layer" flex="dir:top">
              <!-- 页面 -->
              <div class="d2-theme-container-main-body" flex-box="1">
                <transition :name="transitionActive ? 'fade-transverse' : ''">
                  <keep-alive :include="keepAlive">
                    <router-view />
                  </keep-alive>
                </transition>
              </div>
            </div>
          </transition>
        </div>
        <div flex-shrink="0" flex class="d2-theme-footer">
          <span class="d2-mr-20">@2022 上海罗氏制药有限公司工会委员会</span>
          <span><a href="https://beian.miit.gov.cn/">沪ICP备2021032853号-1</a></span>
        </div>
      </div>
      <!-- 在线客服 -->
      <div class="float_button">
        <div class="float_info" @click="onBtnClicked">
          <img src="@/assets/img/kefu.png" />
        </div>
        <el-backtop :right='0'>
          <i class="el-icon-caret-top"></i>
        </el-backtop>
      </div>
      <d2-help v-model="helpVisible"></d2-help>
      <!-- 滚动 -->

    </div>

  </div>
</template>

<script>
  import {
    mapState,
    mapGetters,
    mapActions
  } from "vuex";
  import mixinSearch from "./mixins/search";
  export default {
    name: "d2-layout-header-aside",
    mixins: [mixinSearch],
    components: {
      "d2-menu-side": () => import("./components/menu-side"),
      "d2-menu-header": () => import("./components/menu-header"),
      "d2-tabs": () => import("./components/tabs"),
      "d2-header-fullscreen": () => import("./components/header-fullscreen"),
      "d2-header-search": () => import("./components/header-search"),
      "d2-header-size": () => import("./components/header-size"),
      "d2-header-theme": () => import("./components/header-theme"),
      "d2-header-user": () => import("./components/header-user"),
      "d2-header-error-log": () => import("./components/header-error-log"),
      'd2-help': () => import("./components/help"),
    },
    data() {
      return {
        input: "",
        type: [],
        helpVisible: false,
      };
    },
    computed: {
      ...mapState("d2admin", {
        keepAlive: (state) => state.page.keepAlive,
        grayActive: (state) => state.gray.active,
        transitionActive: (state) => state.transition.active,
      }),
      ...mapGetters("d2admin", {
        themeActiveSetting: "theme/activeSetting",
      }),
      /**
       * @description 最外层容器的背景图片样式
       */
      styleLayoutMainGroup() {
        return {
          ...(this.themeActiveSetting.backgroundImage ? {
            backgroundImage: `url('${this.$baseUrl}${this.themeActiveSetting.backgroundImage}')`,
          } : {}),
        };
      },
    },
    methods: {
      onBtnClicked() {
        this.helpVisible = true;
        console.log(this.helpVisible)
      },
    },
  };
</script>

<style lang="scss">
  // 注册主题
  @import "~@/assets/style/theme/register.scss";

  .el-menu--horizontal>.el-menu-item {
    height: 40px !important;
    line-height: 40px !important;
  }

  .float_info {
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
    color: #666666;
    transition: all 0.3s;
    position: fixed;
    bottom: 436px;
    right: 0;
    width: 50px;
    height: 50px;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    z-index: 999;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 10px;
    cursor: pointer;

    .text {
      font-size: 24px;
      color: #fff;
    }

    img {
      width: 35px;
      height: 35px;
    }
  }

  .el-backtop{width: 50px !important;height: 50px !important;font-size: 30px !important;color: #fff !important;background: rgba(0, 0, 0, 0.5) !important;z-index: 100 !important;}
</style>